module.exports = __webpack_public_path__ + "static/media/size_guide_banner_b.168c00ff.jpg";